




































import { Component, Mixins, Prop, Emit } from 'vue-property-decorator'
import { IFormStore } from '@/store/types'
import { teishutsuInputStore } from '@/store/form/TeishutsuInputFormStore'
import Getsudo from '@/tcw/domain/Getsudo'
import {
  ApiGeneralObjectArrayPayload,
  ApiGeneralSinglePayload,
  ApiPayloadValueType,
  UserSession
} from '@/tcw/api/types'
import FormStoreComponent from '@/tcw/components/FormStoreComponent'
import { KeyInfo } from '@/components/common/form/types'
import TcwGetsudoPicker from '@/components/common/TcwGetsudoPicker.vue'

@Component({
  components: { TcwGetsudoPicker }
})
export default class TeishutsuInputForm extends Mixins(FormStoreComponent) {
  @Prop({ type: Boolean, default: false })
  private editable!: ConstrainBoolean
  @Prop({ type: Getsudo, default: null })
  private getsudo!: Getsudo | null

  @Emit()
  protected changeGetsudo(_getsudo: Getsudo): void {
    //
  }

  @Emit()
  protected saved(): void {
    //
  }

  get getsudoValue(): Getsudo {
    return this.getsudo ? this.getsudo : Getsudo.now(this.shimebi)
  }

  get formName(): string {
    return 'teishutsuInputForm'
  }
  get form(): ApiGeneralSinglePayload {
    return this.storeModule.editData !== null ? this.storeModule.editData : {}
  }
  get storeModule(): IFormStore<ApiGeneralSinglePayload> {
    return teishutsuInputStore
  }
  get keyInfo(): KeyInfo {
    return this.getsudoValue.yearMonth()
  }

  get getsudoStr(): string {
    return this.du.convertDateToStr(this.getsudoValue.getDate(), 'YYYY年MM月')
  }
  get statusName(): string {
    if (typeof this.form.statusName === 'string') {
      return this.form.statusName
    } else {
      return '未作成'
    }
  }
  get statusStr(): string {
    let statusStr = `${this.statusName}`
    if (this.form.status === '1') {
      statusStr += ` ステップ${Number(this.form.genzaiLevel)}`
    }
    return statusStr
  }

  get shozokuStr(): string {
    const shozokuName = this.userInfo.shozokuName ? this.userInfo.shozokuName : ''
    const shokuiName = this.userInfo.shokuiName ? this.userInfo.shokuiName : ''
    return `${shozokuName} ${shokuiName}`
  }
  get alreadyExists(): boolean {
    return this.storeModule.isNewRecord
  }
  get userInfo(): UserSession {
    return this.$tcw.session.user ? this.$tcw.session.user : ({} as UserSession)
  }
  get isOwn(): boolean {
    return this.form.teishutushaId === this.loginUserId
  }
  get shouninUserNames(): string {
    const shouninUserList = this.form?.shouninUserList as ApiGeneralObjectArrayPayload
    if (!Array.isArray(shouninUserList)) {
      return ''
    }
    const shouninUserNameList = shouninUserList.map(shounin => shounin.userName)
    return shouninUserNameList.join(',')
  }

  protected checkSameKey(keyInfo: KeyInfo, editData: ApiGeneralSinglePayload): boolean {
    const [year, month]: number[] = [Number(keyInfo['year']), Number(keyInfo['month'])]
    const oldGetsudo: Getsudo = Getsudo.of(year, month)
    if (typeof editData['getsudo'] === 'string') {
      const newGetsudo = new Date(editData['getsudo'])
      return oldGetsudo.isSameMonth(newGetsudo, this.shimebi)
    }
    return false
  }

  private updateDateValue(fieldName: string, updateValue: ApiPayloadValueType): void {
    let value = updateValue
    if (updateValue instanceof Date) {
      value = this.du.convertDateToStr(updateValue, 'YYYY-MM-DD')
    }
    this.updateValue(fieldName, value)
  }

  protected async afterSaveProc(): Promise<void> {
    this.clearForm()
    this.$tcw.message({
      type: 'success',
      message: '提出情報を登録しました'
    })
    this.goto(`/shounin/${this.getsudoValue.toString()}`)
    this.saved()
  }
}
